export default function isValidJSONObject(string) {
  if (typeof string !== 'string') return false;
  try {
    const json = JSON.parse(string);
    if (json === null || typeof json !== 'object' || Array.isArray(json)) return false;
    return true;
  } catch (e) {
    return false;
  }
}
